module.exports = __webpack_public_path__ + "img/web-p2-c2.2b6e1f82.svg";